// 标签页菜单
const tabsMenu = {
    state: {
        menu: [],
        key: 1 // 标签页序号
    },

    mutations: {
        SET_TABSMENU_MENU: (state, params) => {
            state.menu = params;
        },
        SET_TABSMENU_KEY: (state, params) => {
            state.key = params;
        }
    }
}

export default tabsMenu